import { render, staticRenderFns } from "./numberManagement.vue?vue&type=template&id=105d3b01&scoped=true&"
import script from "./numberManagement.vue?vue&type=script&lang=js&"
export * from "./numberManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105d3b01",
  null
  
)

export default component.exports